import type { SyntheticEvent } from "react";
import { Box, Container, Tab, Tabs } from "@mui/material";
import {
  Outlet,
  useMatch,
  useLocation,
  useNavigate,
  createFileRoute
} from "@tanstack/react-router";

export const Route = createFileRoute("/_app/buyers/$buyerId/_buyerLayout")({
  component: () => {
    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch({ from: "/_app/buyers/$buyerId/_buyerLayout" });
    const buyerId = match.params.buyerId;
    const currentPath = location.pathname;

    const activeTab = currentPath.endsWith("/mortgage")
      ? "mortgage"
      : currentPath.endsWith("/documents")
        ? "documents"
        : currentPath.endsWith("/tools")
          ? "tools"
          : currentPath.endsWith("/calls")
            ? "calls"
            : "profile";

    const handleTabChange = (_: SyntheticEvent, newValue: string) => {
      const basePath = `/buyers/${buyerId}`;
      let newPath: string;

      switch (newValue) {
        case "mortgage":
          newPath = `${basePath}/mortgage`;
          break;
        case "documents":
          newPath = `${basePath}/documents`;
          break;
        case "tools":
          newPath = `${basePath}/tools`;
          break;
        case "calls":
          newPath = `${basePath}/calls`;
          break;
        default:
          newPath = basePath;
      }
      navigate({ to: newPath });
    };

    return (
      <Box>
        <Container
          sx={{
            mt: 2,
            maxWidth: {
              xs: "97%"
            }
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="Buyer Layout Tabs"
          >
            <Tab label="Profile" value="profile" />
            <Tab label="Mortgage" value="mortgage" />
            <Tab label="Documents" value="documents" />
            <Tab label="Calls" value="calls" />
            <Tab label="Tools" value="tools" />
          </Tabs>
        </Container>
        <Outlet />
      </Box>
    );
  }
});
